<template>
	<div class="icon-file-type-wrap">
		<img :src="imagePath" :alt="typeFile" />
	</div>
</template>

<script setup lang="ts">
import docIcon from '@/resources/icons/docs/doc.svg'
import docxIcon from '@/resources/icons/docs/docx.svg'
import pdfIcon from '@/resources/icons/docs/pdf.svg'
import pptIcon from '@/resources/icons/docs/ppt.svg'
import pptxIcon from '@/resources/icons/docs/pptx.svg'
import txtIcon from '@/resources/icons/docs/txt.svg'
import { computed } from 'vue'

const props = defineProps({
	typeFile: { type: String, default: 'txt' }
})

const fileIcons: Record<string, string> = {
	doc: docIcon,
	docx: docxIcon,
	pdf: pdfIcon,
	ppt: pptIcon,
	pptx: pptxIcon,
	txt: txtIcon
}

const imagePath = computed(() => {
	return fileIcons[props.typeFile] || fileIcons['txt']
})
</script>

<style lang="scss" scoped>
.icon-file-type {
	&-wrap {
		border-radius: var(--radius-sm);
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--background-muted);
	}
}
</style>
